import styled from 'styled-components'

/** 퀵 네비게이션 (.quick .scrollTop_btn) — 스크롤 시 우측 하단에 표시 */
export const Root = styled.div.attrs(p => ({
  className: `quick scrollTop_btn${p.$show ? ' show' : ''}`,
}))``

/** 퀵 - 히스토리 (.history) */
export const History = styled.div.attrs({
  className: 'history',
})``

export const HistoryLink = styled.a``
export const HistoryLabel = styled.span``

/** 퀵 - 앱 (.app) */
export const App = styled.div.attrs({
  className: 'app',
})``

export const AppLink = styled.a``

/** 퀵 - TOP (.top) */
export const Top = styled.div.attrs({
  className: 'top',
})`
  cursor: pointer;
`

export const TopIcon = styled.div``

export const TopText = styled.p.attrs({
  className: 'font-serif-en',
})`
  text-align: center;
`

/** 아이콘 래퍼 */
export const IconSpan = styled.span.attrs(p => ({
  className: p.$class || 'icon',
}))``

export const IconSvg = styled.svg.attrs(p => ({
  viewBox: p.$viewBox,
  focusable: 'false',
}))``
